var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"top-10-list"},_vm._l((_vm.top10Data),function(rankItem,index){return _c('Top10ChartItem',{key:index,attrs:{"index":index,"item":rankItem}})}),1),_c('div',{staticClass:"list-gradation"})])}
var staticRenderFns = []

export { render, staticRenderFns }